(function () {
  function syncSheet(root) {
    const checked = root.querySelector('.pj-sheet__size-input:checked');
    if (!checked) return;
    const page = root.closest('.pj-sheet-product') || document;
    page.querySelectorAll('[data-pj-sheet-commit]').forEach(function (el) {
      if (checked.dataset.commitLabel) el.textContent = checked.dataset.commitLabel;
    });
  }

  function placeEta(root) {
    const eta = root.querySelector('[data-pj-eta]');
    if (!eta) return;
    const app =
      root.querySelector('.shopify-app-block') ||
      root.querySelector('[class*="uploadkit"] button, [class*="UploadKit"] button, [class*="antigro"] button, [class*="Antigro"] button');
    if (!app) return;
    const host = app.closest('.shopify-app-block') || app;
    if (host.previousElementSibling !== eta) host.insertAdjacentElement('beforebegin', eta);
  }

  function bindSheet(root) {
    if (!root) return;
    syncSheet(root);
    placeEta(root);
    if (root.dataset.pjSheetBound === 'true') return;
    root.dataset.pjSheetBound = 'true';
    root.addEventListener('change', function (event) {
      if (event.target.classList.contains('pj-sheet__size-input')) syncSheet(root);
    });
  }

  function init() {
    document.querySelectorAll('.pj-sheet').forEach(bindSheet);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
  window.setTimeout(init, 800);
  window.setTimeout(init, 2000);
})();
